<template>
  <a-card :bordered="false">
    <a-tabs defaultActiveKey="1" @change="callback">
      <a-tab-pane tab="PKG" key="1">
        <pkg />
      </a-tab-pane>
      <a-tab-pane tab="APK" key="2" forceRender>
        <apk />
      </a-tab-pane>
      <a-tab-pane tab="图片" key="3" forceRender>
        <u-image />
      </a-tab-pane>
      <a-tab-pane tab="视频" key="4" forceRender>
        <u-video />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import { Apk, UImage, UVideo, Pkg } from './page'
export default {
  components: {
    Apk,
    UImage,
    UVideo,
    Pkg
  },

  data () {
    return {
      visible: {
        edit: false
      },
      columns: [
        {
          title: '文件名',
          dataIndex: 'filename',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: 'MD5',
          dataIndex: 'md5',
          scopedSlots: { customRender: 'md5' }
        },
        {
          title: '大小',
          dataIndex: 'size'
        },
        {
          title: '对应机芯',
          dataIndex: 'core'
        },
        // {
        //   title: '对应软件版本',
        //   dataIndex: 'soft'
        // },
        {
          title: '备注',
          dataIndex: 'note'
        },
        {
          title: '上传时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '最近使用',
          dataIndex: 'lastUse'
        },
        {
          title: '操作',
          dataIndex: 'action',
          // width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      page: {
        content: [{
          id: '1',
          filename: '2019022001.pkg',
          md5: '926cc51f26997e7313c1d81456230968',
          size: '56.18MB',
          core: '5507',
          soft: '...MT5507_V9.00029',
          note: '5507升级-18年第五版',
          creatorName: '管理员',
          gmtCreate: '2018-12-08 10:31:55',
          lastUse: '酒店电视 2578 等5台终端'
        }, {
          id: '2',
          filename: '多媒体广告发布系统1007A.pkg',
          md5: '6d6730eee30715cb3faa5c7cf8e5a6c7',
          size: '72.31MB',
          core: '5507',
          soft: '...MT5507_V9.00029',
          note: '-',
          creator: '管理员',
          gmtCreate: '2018-12-24 12:00:02',
          lastUse: '无'
        }, {
          id: '3',
          filename: 'e30715cb3faa5c7c.pkg',
          md5: 'a39aa711dae09647997a234a39017e6d',
          size: '101.0MB',
          core: 'V551',
          soft: '...MT5507_V9.00029',
          note: 'V551 旧固件存档',
          creator: '管理员',
          gmtCreate: '2019-01-02 17:13:40',
          lastUse: '酒店电视 2580 等1台终端'
        }],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [],
      selectedRows: [],

      corps: [{
        id: '1',
        name: '长虹国际酒店'
      }, {
        id: '2',
        name: '富乐山国际酒店'
      }, {
        id: '3',
        name: '首旅如家'
      }]
    }
  },

  computed: {
    rowSelection () {
      const ctx = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          ctx.unitIds = selectedRowKeys
          console.log(ctx.unitIds)
        }
      }
    }
  },

  methods: {
    handleEdit (record) {
      this.visible.edit = true
    },

    handleOk () {

    },

    callback (e) {
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>

<style lang="less" scoped>
  .forty {
    width: 40%;
  }

  .sixty {
    width: 60%;
  }

  .hundred {
    width: 100%;
  }

  .card-container > .ant-tabs-card > .ant-tabs-content {
    height: 120px;
    margin-top: -16px;
  }

  .card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    background: #fff;
    padding: 16px;
  }

  .card-container > .ant-tabs-card > .ant-tabs-bar {
    border-color: #fff;
  }

  .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
  }

  .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
    border-color: #fff;
    background: #fff;
  }
</style>
